import { ActionProps } from '../../../model';

export class ShowSnackbarInfo {
  static readonly type = '[SNACKBAR] Show Info';
  readonly actionType = ShowSnackbarInfo.type;
  constructor(
    public bodyMessage: string,
    public params: { [key: string]: string } = {}
  ) {}
}

export class ShowSnackbarSuccess {
  static readonly type = '[SNACKBAR] Show Success';
  readonly actionType = ShowSnackbarSuccess.type;
  constructor(
    public bodyMessage: string,
    public params: { [key: string]: string } = {},
    public actionProps?: ActionProps
  ) {}
}

export class ShowSnackbarSummaryWarning {
  static readonly type = '[SNACKBAR] Show Summary Warning';
  readonly actionType = ShowSnackbarWarning.type;
  constructor(
    public bodyMessage: string,
    public params: { [key: string]: string } = {},
    public actionProps?: ActionProps
  ) {}
}

export class ShowSnackbarError {
  static readonly type = '[SNACKBAR] Show Error';
  readonly actionType = ShowSnackbarError.type;
  constructor(
    public bodyMessage: string,
    public params: { [key: string]: string } = {},
    public actionProps?: ActionProps
  ) {}
}

export class ShowSnackbarWarning {
  static readonly type = '[SNACKBAR] Show Warning';
  readonly actionType = ShowSnackbarWarning.type;
  constructor(
    public bodyMessage: string,
    public params: { [key: string]: string } = {}
  ) {}
}

export class CloseSnackbar {
  static readonly type = '[SNACKBAR] close';
  readonly actionType = CloseSnackbar.type;
}
